import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './views/Home';
import Sobre from './views/Sobre';
import {Meet} from './views/Meet';
import { Recursos } from './views/Recursos';
import { ReproducaoHumanaAssistida } from './views/ReproducaoHumanaAssistida';
import { CuidadosSaudeAtencaoPrimaria } from './views/CuidadosSaudeAtencaoPrimaria';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/solicitar-reuniao" element={<Meet />} />
          <Route path="/recursos" element={<Recursos />} />
          <Route path="/reproducao-humana-assistida" element={<ReproducaoHumanaAssistida />} />
          <Route path="/cuidados-saude-atencao-primaria" element={<CuidadosSaudeAtencaoPrimaria />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;